export const CHANGE_ORGANIZATION_SELECT = 'CHANGE_ORGANIZATION_SELECT';
export const CHANGE_JIT_ORGANIZATION_SELECT = 'CHANGE_JIT_ORGANIZATION_SELECT';
